// const BROADBAND_SCORES = {
//   none: [0, 0, 0, 0],
//   0: [255, 255, 255],
//   1: [214, 223, 244],
//   2: [169, 182, 210],
//   3: [123, 139, 175],
//   4: [78, 98, 140],
//   5: [20, 44, 96],
// };

const BROADBAND_SCORES = {
  none: [0, 0, 0, 0],
  0: [255, 255, 255],
  // Uncomment for lighter color set.
  // 1: [228, 243, 252],
  // 2: [219, 237, 247],
  // 3: [206, 230, 245],
  // 4: [181, 216, 238],
  // 5: [170, 202, 229],

  1: [228, 243, 252],
  2: [206, 230, 245],
  3: [156, 196, 228],
  4: [116, 163, 204],
  5: [58, 108, 155],

  // Uncomment for darker color set.
  // 1: [205, 228, 242],
  // 2: [161, 196, 223],
  // 3: [116, 163, 204],
  // 4: [88, 136, 180],
  // 5: [58, 108, 155],

  // Uncomment for darkest color set.
  // 1: [205, 228, 242],
  // 2: [156, 196, 228],
  // 3: [107, 164, 214],
  // 4: [58, 108, 155],
  // 5: [6, 49, 93],
};

const BROADBAND_SCORES_lIGHTER_COLORS = {
  none: [0, 0, 0, 0],
  0: [245, 247, 248],
  1: [239, 244, 248],
  2: [238, 243, 247],
  3: [235, 241, 246],
  4: [230, 239, 245],
  5: [228, 236, 243],
};

let broadbandColor = function (broadbandScore = 0, isLighter = false) {
  let scoreBucket = Math.ceil(parseFloat(broadbandScore));

  if (isLighter === true) {
    return BROADBAND_SCORES_lIGHTER_COLORS[scoreBucket];
  } else {
    return BROADBAND_SCORES[scoreBucket];
  }
};

export { BROADBAND_SCORES, broadbandColor };
